import { FormEvent, useEffect, useState } from "react";

type Observation = {
  observation_id: string;
  candidate_id: string;
  series_sha256: string;
  activation_cursor: number;
  activation_event: string;
  terminal_event: string | null;
  trade_permission: string;
};

const defaultSeriesHash = "0".repeat(64);

export default function ResearchObservations({ token, onClose }: { token: string; onClose: () => void }) {
  const [rows, setRows] = useState<Observation[]>([]);
  const [candidateId, setCandidateId] = useState("CAND-TRAJECTORY-RETEST-001");
  const [seriesHash, setSeriesHash] = useState(defaultSeriesHash);
  const [cursor, setCursor] = useState("0");
  const [event, setEvent] = useState("bounce");
  const [terminal, setTerminal] = useState("");
  const [message, setMessage] = useState("");

  const load = () => {
    fetch("/api/research-observations", { headers: { Authorization: "Bearer " + token } })
      .then(async (response) => {
        if (!response.ok) throw new Error("Не удалось загрузить журнал");
        setRows((await response.json()) as Observation[]);
      })
      .catch((reason: unknown) => setMessage(reason instanceof Error ? reason.message : "Ошибка"));
  };

  useEffect(load, [token]);

  const submit = async (form: FormEvent) => {
    form.preventDefault();
    setMessage("");
    const response = await fetch("/api/research-observations", {
      method: "POST",
      headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
      body: JSON.stringify({
        candidate_id: candidateId,
        series_sha256: seriesHash,
        activation_cursor: Number(cursor),
        activation_event: event,
        terminal_event: terminal || null,
      }),
    });
    if (!response.ok) {
      setMessage("Наблюдение не сохранено: проверьте поля");
      return;
    }
    setMessage("Исследовательское наблюдение сохранено. Торговля не выполнялась.");
    load();
  };

  return <section className="knowledge-overlay"><div className="rules-page">
    <header><div><small>Постоянный журнал · research-only</small><h1>Наблюдения закрытых баров</h1></div><button onClick={onClose}>Закрыть</button></header>
    <p>Журнал сохраняет только факты исследования. Приказы, позиции, PnL и исполнение запрещены.</p>
    <form className="rule-card rule-unknown" onSubmit={submit}>
      <label>Семейство <select value={candidateId} onChange={(e) => setCandidateId(e.target.value)}><option>CAND-TRAJECTORY-RETEST-001</option><option>CAND-P14-EXTENSION-001</option><option>CAND-LADDER-001</option><option>CAND-FLAT-CONTINUATION-001</option></select></label>
      <label>SHA-256 ряда <input value={seriesHash} maxLength={64} onChange={(e) => setSeriesHash(e.target.value)} /></label>
      <label>Бар активации <input value={cursor} inputMode="numeric" onChange={(e) => setCursor(e.target.value)} /></label>
      <label>Событие <input value={event} onChange={(e) => setEvent(e.target.value)} /></label>
      <label>Конечное событие <input value={terminal} onChange={(e) => setTerminal(e.target.value)} /></label>
      <button className="primary" type="submit">Сохранить наблюдение</button>
    </form>
    {message && <p className="knowledge-error">{message}</p>}
    <div className="rule-list">{rows.map((row) => <article className="rule-card rule-unknown" key={row.observation_id}><header><div><code>{row.observation_id}</code><h2>{row.candidate_id}</h2><small>бар {row.activation_cursor} · {row.series_sha256.slice(0, 12)}…</small></div><span className="research-denied">{row.trade_permission}</span></header><footer><span>Активация: {row.activation_event}</span><span>Конец: {row.terminal_event ?? "не указан"}</span></footer></article>)}</div>
  </div></section>;
}
